import React, { FC, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Navbar from '../../components/Navbar';
import Banner from '../../components/Banner';
import SideBar from '../../components/SideBar';
import Modal from '../../components/Modal';
import Tour from '../../components/Tour';
import ChatWidget from '../../components/ChatWidget';
import imgURL from '../../lib/imgURL';
import useRedirect from '../../hooks/useRedirect';
import Button from '../../components/Button';
import { CHAT_WIDGET_ACCESSIBLE_EMAIL_DOMAINS, CHAT_WIDGET_ROLL_OUT_MODULO, UiRoutes } from '../../lib/constants';
import { isLiveDomain } from '../../lib/helper';
import { KAM_SOURCE } from './constants';
import { Props, WelcomeProps } from './typing';
import './style.scss';
import { useLocation } from 'react-router-dom';

const WelcomeToPlural: FC<WelcomeProps> = (props): JSX.Element => {
  const { setShowWelcome } = props;
  const { push } = useRedirect();
  return (
    <>
      <img
        className='welcome-modal-close'
        src={imgURL['welcome-close-icon']}
        alt='Close'
        onClick={() => {
          setShowWelcome(false);
        }}
      />
      <div className='modal-body-wrapper welcome-wrapper'>
        <div className='welcome-content'>
          <h3 className='title'>Welcome to Plural!</h3>
          <div className='text-content'>
            <p className='content'>
              You&#39;re in test environment — Fill in your business profile to
              start accepting payments. Any progress you make will be saved, so
              you can always finish later.
            </p>
            <p className='content'>
              Complete your profile to start accepting payments from your
              customers
            </p>
          </div>
          <div className='welcome-action'>
            <Button
              btnStyleClass='primary-button'
              label='Complete your KYC'
              onClick={() => {
                setShowWelcome(false);
                push(UiRoutes.PROFILE);
              }}
              enable
            />
            <Button
              btnStyleClass='secondry-button'
              label='Try out the dashboard'
              onClick={() => {
                setShowWelcome(false);
              }}
              enable
            />
          </div>
        </div>
        <div className='welcome-icon-container'>
          <img
            className='welcome-icon'
            src={imgURL['welcome-icon']}
            alt='Plural'
          />
        </div>
      </div>
    </>
  );
};

const Payment: FC<Props> = (props): JSX.Element => {
  const [showWelcome, setShowWelcome] = useState(false);
  const { leadId, virtualStoreId, onboardingSource } = props;
  const [showTourByBtnClick, setShowTourByBtnClick] = useState(false);
  const location = useLocation();
  const isProfileSubmitPage = location.pathname === '/user-verification/profile-submitted';
  useEffect(() => { }, [props.MerchantId]);
  const isChatbotAccessible = ()=>{
    const isQA = process.env.REACT_APP_BUILD_ENV === 'qa';
    const mappedProducts = props?.mappedProducts;
    const edgeProduct = mappedProducts?.find(product => product.name?.toLowerCase() === 'edge');
    const isStillOnboarding = edgeProduct?.mid && edgeProduct?.mid !== -1;
    const userEmail = props?.userEmail;
    const userEmailDomain = userEmail?.split('@')[1];
    const isDomainWhitelisted =  CHAT_WIDGET_ACCESSIBLE_EMAIL_DOMAINS.includes(userEmailDomain);
    const dashboardMid = (Number(props.merchantId) ) || 0;
    const isChatWidgetRolledOut = dashboardMid % CHAT_WIDGET_ROLL_OUT_MODULO === 0;
    if (isStillOnboarding && (isQA || isDomainWhitelisted || isChatWidgetRolledOut)) {
      return true;
    }
    return false;
  };
  const shouldShowChatWidget = isChatbotAccessible();
  return (
    <React.Fragment>
      <div className={`wrapper ${isProfileSubmitPage ? 'no-sidebar' : ''}`}>
        {!props.isAdmin && showWelcome && (
          <Modal
            modalWrapperClass={'welcome-plural'}
            ModalBody={WelcomeToPlural}
            modalBodyProps={{
              showWelcome,
              setShowWelcome,
            }}
          />
        )}
        {!isProfileSubmitPage && <SideBar />}
        <div id='content'>
          <Navbar />
          {onboardingSource?.toLocaleLowerCase() !== KAM_SOURCE &&
            isLiveDomain() &&
            (leadId || virtualStoreId) ? (
            <Banner />
          ) : (
            <></>
          )}

          <div
            className={`${props.isCollapsed ? 'content-pane-collapsed' : 'content-pane'
              } ${onboardingSource?.toLocaleLowerCase() !== KAM_SOURCE &&
                isLiveDomain() &&
                (leadId || virtualStoreId)
                ? 'banner-added'
                : ''
              }`}
          >
            {props.children}
          </div>
          {
            // hide button if showGuidedTour is true
            !shouldShowChatWidget && !props.isAdmin && !props?.showGuidedTour ? (
              <Button
                btnStyleType='float'
                label='Product Tour'
                enable
                onClick={() => setShowTourByBtnClick(true)}
                btnIcon={
                  <img className='back-icon' src={imgURL['play-circle']} />
                }
                btnIconPosition='left'
              />
            ) : (
              ''
            )
          }

          {!shouldShowChatWidget && !props.isAdmin ? (
            <Tour
              showTourByBtnClick={showTourByBtnClick}
              setShowTourByBtnClick={(value) => setShowTourByBtnClick(value)}
            />
          ) : (
            ''
          )}

          {shouldShowChatWidget && <ChatWidget />}
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = ({ sidebarReducer, loginReducer }) => ({
  isCollapsed: sidebarReducer.isCollapsed,
  isAdmin: loginReducer.loginState.isAdmin,
  leadId: loginReducer.loginState.leadId,
  onboardingSource: loginReducer.loginState.onboardingSource,
  virtualStoreId: loginReducer.loginState.virtualStoreId,
  MerchantId: loginReducer.loginState.MerchantId,
  showGuidedTour: loginReducer?.loginState?.showGuidedTour,
  merchantId: loginReducer.loginState.MerchantId,
  userEmail: loginReducer.loginState.UserEmail,
  mappedProducts: loginReducer.loginState.mappedProducts,
});

export default connect(mapStateToProps)(Payment);
